import Markdown from 'react-markdown'
import rehypeHighlight from "rehype-highlight"
import remarkGfm from 'remark-gfm'


export interface CreateNewPolicyProps {
    terms?: string;
}

export function Policy({ terms = "" }: CreateNewPolicyProps) {

    return <div className="grid grid-cols-12 gap-4 w-full h-full">

        <div className="col-span-12 markdown-body overflow-auto h-full">
            <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeHighlight]}>{terms}</Markdown>
        </div>
    </div >

}